import { Box, ColorOptions } from '@jfs/ui-new'
import { FlatList } from 'react-native'
interface ExpandableComponentProps {
  item: any
  onHeaderClick: any
  renderHeader: any
  renderData: any
  index: number
  childListFooter?: any
  theme: any
}

const ExpandableComponent = ({
  item,
  index,
  onHeaderClick,
  renderHeader,
  renderData,
  childListFooter,
  theme,
}: ExpandableComponentProps) => {
  return (
    <Box nativeID="expandableItem" backgroundColor={theme.bodyBgColor as ColorOptions}>
      <Box onPress={() => onHeaderClick(index)} underlayColor="TRANSPARENT">
        {renderHeader({ item, index, onHeaderClick })}
      </Box>
      {item.isExpanded && <FlatList data={item.data} renderItem={renderData} />}
      {childListFooter && childListFooter()}
    </Box>
  )
}

export { ExpandableComponent }
